import axios from "axios";
import { N1CO_BASE_URL } from "../config";
import { getToken } from "./N1coAuthService";

export const http = axios.create({
  baseURL: N1CO_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Inyecta automáticamente el Bearer token
http.interceptors.request.use(async (config) => {
  const token = await getToken();
  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
